<div class="section-title">
  <span class="section-title__title paragraph2">{{ title }}</span>
  <span class="section-title__value heading2 ">{{ value   | currency:'AUD':'symbol':'1.0-0' }}</span>
</div>
